var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackgroundWatch = function SvgBackgroundWatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 477.802,
    height: 520.475
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    "data-name": "Group 828",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "m408.563 378.182 15.608-27.6 12.92 5.967-16.758 29.63Z",
    "data-name": "Path 367"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m408.563 378.182 15.608-27.6 12.92 5.967-16.758 29.63Z",
    "data-name": "Path 368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.675 385.481c-9.29 16.431-16.366 17.193-17.788 16.387s-16.182-11.284-16.182-11.284-6.81-3.473-4.307-6.569a68.5 68.5 0 0 0 17.295-30.579c1.361-3.742 7.851.3 7.851.3s16.581 7.246 18.006 8.052 4.416 7.26-4.875 23.69",
    "data-name": "Path 369"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M453.675 385.481c-9.29 16.431-16.366 17.193-17.788 16.387s-16.182-11.284-16.182-11.284-6.81-3.473-4.307-6.569a68.5 68.5 0 0 0 17.295-30.579c1.361-3.742 7.851.3 7.851.3s16.581 7.246 18.006 8.052 4.415 7.262-4.875 23.693Z",
    "data-name": "Path 370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.217 286.525v-63.281a3.5 3.5 0 0 1 3.49-3.49h23.241c1.919 0 8.726 10.2 8.726 35.131s-6.807 35.131-8.726 35.131",
    "data-name": "Path 371"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M468.949 290.015h-23.238a3.5 3.5 0 0 1-3.49-3.49v-63.281a3.5 3.5 0 0 1 3.49-3.49h23.241c1.919 0 8.726 10.2 8.726 35.131s-6.811 35.13-8.729 35.13Z",
    "data-name": "Path 372"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m423.724 158.693-14.056-28.422 12.2-7.331 15.087 30.511Z",
    "data-name": "Path 373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.117 125.485c8.365 16.921 5.021 23.2 3.552 23.925s-18.427 7.042-18.427 7.042-6.7 3.677-7.855-.133a68.4 68.4 0 0 0-15.57-31.491c-2.327-3.232 4.664-6.324 4.664-6.324s15.315-9.641 16.781-10.369 8.488.429 16.856 17.349",
    "data-name": "Path 374"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M455.117 125.485c8.365 16.921 5.021 23.2 3.552 23.925s-18.427 7.042-18.427 7.042-6.7 3.677-7.855-.133a68.4 68.4 0 0 0-15.57-31.491c-2.327-3.232 4.664-6.324 4.664-6.324s15.315-9.641 16.781-10.369 8.487.429 16.855 17.35Z",
    "data-name": "Path 375"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M51.803 114.613s24.99-55.569 26.442-95.428c0-.139.007-.333.374-.609l28.1-18.339v76.147l-47.568 37.648Z",
    "data-name": "Path 376"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M398.292 114.613s-24.99-55.569-26.442-95.428c0-.139-.007-.333-.374-.609L343.376.237v76.147l47.571 37.648Z",
    "data-name": "Path 377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.698 396.795s-24.99 64.635-26.442 104.5c0 .136-.007.327-.378.605l-28.1 18.339v-85.218l47.571-37.645Z",
    "data-name": "Path 378"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M397.698 396.795s-24.99 64.635-26.442 104.5c0 .136-.007.327-.378.605l-28.1 18.339v-85.218l47.571-37.645Z",
    "data-name": "Path 379"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M51.197 396.795s24.99 64.635 26.442 104.5c0 .136.007.327.378.605l28.1 18.339v-85.218l-47.571-37.645Z",
    "data-name": "Path 380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.126 35.204c6.491.684 9.685-4.5 10.267-4.439l2.058.214.051.007 2.027.432c.568.122 2 6.038 8.385 7.4s10.107-3.467 10.675-3.344l2.031.432.044.01 1.973.643c.555.177 1.361 6.215 7.569 8.232s10.413-2.391 10.967-2.211l1.97.64.044.02 1.895.84c.531.238.7 6.327 6.668 8.981s10.6-1.289 11.138-1.055 1.891.844 1.891.844l.044.024 1.793 1.034c.507.293.041 6.365 5.695 9.627s10.681-.174 11.185.119l1.793 1.038.044.024 1.677 1.218c.469.344-.626 6.334 4.654 10.171s10.641.942 11.114 1.286l1.674 1.218.041.031 1.541 1.388c.432.388-1.286 6.232 3.565 10.6s10.484 2.051 10.917 2.439 1.541 1.388 1.541 1.388l.034.034 1.388 1.541c.388.432-1.929 6.062 2.439 10.917s10.212 3.133 10.6 3.565l1.388 1.541.031.037 1.218 1.677c.34.469-2.551 5.831 1.286 11.114s9.828 4.184 10.171 4.654l1.218 1.677.027.041 1.038 1.8c.293.507-3.15 5.528.116 11.185s9.335 5.188 9.627 5.691 1.034 1.8 1.034 1.8l.024.041s.605 1.364.844 1.895-3.708 5.174-1.055 11.138 8.743 6.137 8.981 6.668.844 1.895.844 1.895l.017.044s.459 1.419.643 1.97-4.229 4.756-2.215 10.967 8.056 7.018 8.233 7.569.643 1.973.643 1.973l.014.044.432 2.031c.122.572-4.7 4.286-3.347 10.671s7.276 7.821 7.4 8.389.429 2.027.429 2.027l.01.048.218 2.062c.062.579-5.127 3.773-4.446 10.267s6.423 8.539 6.481 9.117.218 2.061.218 2.061v2.123c0 .582-5.494 3.215-5.494 9.743s5.494 9.161 5.494 9.746v2.12s-.153 1.483-.218 2.061-5.8 2.626-6.477 9.117 4.5 9.688 4.443 10.267-.218 2.062-.218 2.062l-.007.048s-.313 1.459-.432 2.027-6.038 2-7.4 8.389 3.47 10.1 3.347 10.675l-.432 2.027-.01.048-.643 1.97c-.177.555-6.215 1.364-8.236 7.573s2.395 10.41 2.215 10.964l-.643 1.973-.017.044s-.606 1.361-.844 1.891-6.324.7-8.977 6.671 1.289 10.6 1.051 11.134l-.844 1.895-.02.044s-.745 1.289-1.034 1.793-6.365.041-9.627 5.695.17 10.678-.119 11.185-1.038 1.793-1.038 1.793l-.023.041s-.878 1.208-1.218 1.68-6.338-.629-10.175 4.654-.939 10.641-1.283 11.11-1.218 1.677-1.218 1.677l-.031.037-1.388 1.541c-.388.432-6.232-1.286-10.6 3.568s-2.051 10.481-2.439 10.917-1.388 1.538-1.388 1.538l-.034.037-1.541 1.384c-.432.391-6.062-1.925-10.917 2.439s-3.133 10.212-3.568 10.6-1.538 1.384-1.538 1.384l-.041.031s-1.2.878-1.674 1.221-5.831-2.551-11.114 1.286-4.184 9.824-4.654 10.168l-1.677 1.218-.041.027s-1.289.748-1.8 1.037-5.531-3.147-11.185.116-5.188 9.338-5.691 9.627l-1.8 1.038-.044.024s-1.361.606-1.891.844-5.174-3.708-11.138-1.055-6.137 8.743-6.668 8.981-1.895.844-1.895.844l-.044.017s-1.418.459-1.969.64-4.759-4.229-10.967-2.211-7.015 8.056-7.573 8.236l-1.97.639-.044.01s-1.459.313-2.031.432-4.286-4.7-10.672-3.344-7.821 7.273-8.389 7.4-2.027.432-2.027.432l-.051.007-2.058.218c-.578.061-3.776-5.126-10.267-4.443s-8.538 6.419-9.12 6.477-2.058.221-2.058.221h-2.122c-.582 0-3.215-5.49-9.743-5.49s-9.165 5.49-9.746 5.49h-2.123l-2.058-.218c-.582-.061-2.626-5.8-9.12-6.481s-9.682 4.5-10.263 4.443l-2.062-.218-.047-.007-2.028-.432c-.569-.122-2-6.038-8.389-7.4s-10.107 3.466-10.675 3.344-2.028-.429-2.028-.429l-.048-.014s-1.419-.463-1.97-.639-1.361-6.219-7.573-8.233-10.41 2.388-10.964 2.208-1.97-.636-1.97-.636l-.047-.02s-1.361-.606-1.895-.84-.7-6.327-6.668-8.984-10.6 1.293-11.134 1.055-1.895-.84-1.895-.84l-.041-.024-1.8-1.038c-.5-.293-.037-6.365-5.691-9.627s-10.678.173-11.185-.116-1.793-1.038-1.793-1.038l-.044-.027s-1.2-.878-1.677-1.218.629-6.334-4.654-10.168-10.641-.946-11.114-1.286-1.677-1.221-1.677-1.221l-.037-.031s-1.106-1-1.541-1.388 1.286-6.232-3.565-10.6-10.484-2.051-10.917-2.439-1.541-1.388-1.541-1.388l-.031-.034s-1-1.106-1.391-1.541 1.932-6.062-2.436-10.913-10.212-3.137-10.6-3.569l-1.388-1.541-.031-.038-1.218-1.677c-.344-.469 2.551-5.831-1.286-11.11s-9.828-4.184-10.168-4.654l-1.221-1.681-.024-.037-1.038-1.8c-.293-.507 3.15-5.531-.116-11.185s-9.338-5.191-9.627-5.695-1.038-1.793-1.038-1.793l-.024-.044s-.606-1.364-.844-1.895 3.711-5.171 1.055-11.134-8.746-6.137-8.981-6.671-.844-1.891-.844-1.891l-.017-.048s-.463-1.419-.639-1.97 4.228-4.756 2.211-10.964-8.052-7.018-8.236-7.572-.636-1.97-.636-1.97l-.014-.047s-.313-1.459-.432-2.028 4.7-4.29 3.344-10.672-7.277-7.821-7.4-8.392-.429-2.027-.429-2.027l-.01-.048s-.157-1.483-.214-2.061 5.127-3.773 4.443-10.267-6.419-8.535-6.48-9.114l-.214-2.062v-2.123c0-.582 5.491-3.218 5.491-9.746s-5.491-9.161-5.491-9.743v-2.123l.218-2.062c.061-.579 5.8-2.623 6.48-9.117s-4.5-9.685-4.443-10.267.214-2.062.214-2.062l.007-.048s.313-1.456.432-2.024 6.042-2.007 7.4-8.392-3.467-10.1-3.344-10.671.432-2.031.432-2.031l.01-.044s.459-1.419.64-1.973 6.215-1.361 8.236-7.569-2.392-10.413-2.211-10.967.639-1.97.639-1.97l.017-.044s.605-1.364.844-1.895 6.324-.7 8.981-6.668-1.289-10.6-1.055-11.134.844-1.9.844-1.9l.02-.041s.749-1.293 1.038-1.8 6.365-.037 9.627-5.691-.174-10.682.116-11.185l1.038-1.8.024-.041s.878-1.208 1.221-1.677 6.334.626 10.172-4.654.939-10.641 1.282-11.114l1.218-1.677.031-.037 1.388-1.541c.388-.432 6.232 1.286 10.6-3.565s2.048-10.485 2.436-10.916l1.391-1.541.031-.034s1.112-1 1.541-1.388 6.066 1.929 10.917-2.439 3.133-10.212 3.565-10.6l1.541-1.388.037-.031s1.211-.878 1.677-1.218 5.831 2.551 11.114-1.286 4.184-9.828 4.654-10.172 1.677-1.218 1.677-1.218l.041-.027 1.8-1.034c.5-.293 5.531 3.147 11.185-.119s5.191-9.335 5.691-9.627l1.8-1.037.041-.02s1.364-.606 1.895-.844 5.171 3.708 11.134 1.055 6.137-8.746 6.668-8.981l1.895-.844.048-.017 1.969-.643c.555-.177 4.756 4.229 10.964 2.215s7.018-8.055 7.572-8.236l1.97-.64.048-.014s1.456-.309 2.024-.432 4.29 4.7 10.675 3.347 7.821-7.277 8.392-7.4 2.028-.429 2.028-.429l.044-.01s1.487-.156 2.065-.214 3.773 5.123 10.263 4.443 8.539-6.419 9.117-6.484 2.062-.214 2.062-.214h2.123c.582 0 3.218 5.491 9.746 5.491s9.161-5.491 9.743-5.491h2.072",
    "data-name": "Path 381"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M237.948 28.509s1.483.153 2.058.214 2.626 5.8 9.12 6.481 9.685-4.5 10.267-4.439l2.058.214.051.007 2.027.432c.568.122 2 6.038 8.385 7.4s10.107-3.467 10.675-3.344l2.031.432.044.01 1.973.643c.555.177 1.361 6.215 7.569 8.232s10.413-2.391 10.967-2.211l1.97.64.044.02 1.895.84c.531.238.7 6.327 6.668 8.981s10.6-1.289 11.138-1.055 1.891.844 1.891.844l.044.024 1.793 1.034c.507.293.041 6.365 5.695 9.627s10.681-.174 11.185.119l1.793 1.038.044.024 1.677 1.218c.469.344-.626 6.334 4.654 10.171s10.641.942 11.114 1.286l1.674 1.218.041.031 1.541 1.388c.432.388-1.286 6.232 3.565 10.6s10.484 2.051 10.917 2.439 1.541 1.388 1.541 1.388l.034.034 1.388 1.541c.388.432-1.929 6.062 2.439 10.917s10.212 3.133 10.6 3.565l1.388 1.541.031.037 1.218 1.677c.34.469-2.551 5.831 1.286 11.114s9.828 4.184 10.171 4.654l1.218 1.677.027.041 1.038 1.8c.293.507-3.15 5.528.116 11.185s9.335 5.188 9.627 5.691 1.034 1.8 1.034 1.8l.024.041s.605 1.364.844 1.895-3.708 5.174-1.055 11.138 8.743 6.137 8.981 6.668.844 1.895.844 1.895l.017.044s.459 1.419.643 1.97-4.229 4.756-2.215 10.967 8.056 7.018 8.233 7.569.643 1.973.643 1.973l.014.044.432 2.031c.122.572-4.7 4.286-3.347 10.671s7.276 7.821 7.4 8.389.429 2.027.429 2.027l.01.048.218 2.062c.062.579-5.127 3.773-4.446 10.267s6.423 8.539 6.481 9.117.218 2.061.218 2.061v2.123c0 .582-5.494 3.215-5.494 9.743s5.494 9.161 5.494 9.746v2.12s-.153 1.483-.218 2.061-5.8 2.626-6.477 9.117 4.5 9.688 4.443 10.267-.218 2.062-.218 2.062l-.007.048s-.313 1.459-.432 2.027-6.038 2-7.4 8.389 3.47 10.1 3.347 10.675l-.432 2.027-.01.048-.643 1.97c-.177.555-6.215 1.364-8.236 7.573s2.395 10.41 2.215 10.964l-.643 1.973-.017.044s-.606 1.361-.844 1.891-6.324.7-8.977 6.671 1.289 10.6 1.051 11.134l-.844 1.895-.02.044s-.745 1.289-1.034 1.793-6.365.041-9.627 5.695.17 10.678-.119 11.185-1.038 1.793-1.038 1.793l-.023.041s-.878 1.208-1.218 1.68-6.338-.629-10.175 4.654-.939 10.641-1.283 11.11-1.218 1.677-1.218 1.677l-.031.037-1.388 1.541c-.388.432-6.232-1.286-10.6 3.568s-2.051 10.481-2.439 10.917-1.388 1.538-1.388 1.538l-.034.037-1.541 1.384c-.432.391-6.062-1.925-10.917 2.439s-3.133 10.212-3.568 10.6-1.538 1.384-1.538 1.384l-.041.031s-1.2.878-1.674 1.221-5.831-2.551-11.114 1.286-4.184 9.824-4.654 10.168l-1.677 1.218-.041.027s-1.289.748-1.8 1.037-5.531-3.147-11.185.116-5.188 9.338-5.691 9.627l-1.8 1.038-.044.024s-1.361.606-1.891.844-5.174-3.708-11.138-1.055-6.137 8.743-6.668 8.981-1.895.844-1.895.844l-.044.017s-1.418.459-1.969.64-4.759-4.229-10.967-2.211-7.015 8.056-7.573 8.236l-1.97.639-.044.01s-1.459.313-2.031.432-4.286-4.7-10.672-3.344-7.821 7.273-8.389 7.4-2.027.432-2.027.432l-.051.007-2.058.218c-.578.061-3.776-5.126-10.267-4.443s-8.538 6.419-9.12 6.477-2.058.221-2.058.221h-2.122c-.582 0-3.215-5.49-9.743-5.49s-9.165 5.49-9.746 5.49h-2.123l-2.058-.218c-.582-.061-2.626-5.8-9.12-6.481s-9.682 4.5-10.263 4.443l-2.062-.218-.047-.007-2.028-.432c-.569-.122-2-6.038-8.389-7.4s-10.107 3.466-10.675 3.344-2.028-.429-2.028-.429l-.048-.014s-1.419-.463-1.97-.639-1.361-6.219-7.573-8.233-10.41 2.388-10.964 2.208-1.97-.636-1.97-.636l-.047-.02s-1.361-.606-1.895-.84-.7-6.327-6.668-8.984-10.6 1.293-11.134 1.055-1.895-.84-1.895-.84l-.041-.024-1.8-1.038c-.5-.293-.037-6.365-5.691-9.627s-10.678.173-11.185-.116-1.793-1.038-1.793-1.038l-.044-.027s-1.2-.878-1.677-1.218.629-6.334-4.654-10.168-10.641-.946-11.114-1.286-1.677-1.221-1.677-1.221l-.037-.031s-1.106-1-1.541-1.388 1.286-6.232-3.565-10.6-10.484-2.051-10.917-2.439-1.541-1.388-1.541-1.388l-.031-.034s-1-1.106-1.391-1.541 1.932-6.062-2.436-10.913-10.212-3.137-10.6-3.569l-1.388-1.541-.031-.038-1.218-1.677c-.344-.469 2.551-5.831-1.286-11.11s-9.828-4.184-10.168-4.654l-1.221-1.681-.024-.037-1.038-1.8c-.293-.507 3.15-5.531-.116-11.185s-9.338-5.191-9.627-5.695-1.038-1.793-1.038-1.793l-.024-.044s-.606-1.364-.844-1.895 3.711-5.171 1.055-11.134-8.746-6.137-8.981-6.671-.844-1.891-.844-1.891l-.017-.048s-.463-1.419-.639-1.97 4.228-4.756 2.211-10.964-8.052-7.018-8.236-7.572-.636-1.97-.636-1.97l-.014-.047s-.313-1.459-.432-2.028 4.7-4.29 3.344-10.672-7.277-7.821-7.4-8.392-.429-2.027-.429-2.027l-.01-.048s-.157-1.483-.214-2.061 5.127-3.773 4.443-10.267-6.419-8.535-6.48-9.114l-.214-2.062v-2.123c0-.582 5.491-3.218 5.491-9.746s-5.491-9.161-5.491-9.743v-2.123l.218-2.062c.061-.579 5.8-2.623 6.48-9.117s-4.5-9.685-4.443-10.267.214-2.062.214-2.062l.007-.048s.313-1.456.432-2.024 6.042-2.007 7.4-8.392-3.467-10.1-3.344-10.671.432-2.031.432-2.031l.01-.044s.459-1.419.64-1.973 6.215-1.361 8.236-7.569-2.392-10.413-2.211-10.967.639-1.97.639-1.97l.017-.044s.605-1.364.844-1.895 6.324-.7 8.981-6.668-1.289-10.6-1.055-11.134.844-1.9.844-1.9l.02-.041s.749-1.293 1.038-1.8 6.365-.037 9.627-5.691-.174-10.682.116-11.185l1.038-1.8.024-.041s.878-1.208 1.221-1.677 6.334.626 10.172-4.654.939-10.641 1.282-11.114l1.218-1.677.031-.037 1.388-1.541c.388-.432 6.232 1.286 10.6-3.565s2.048-10.485 2.436-10.916l1.391-1.541.031-.034s1.112-1 1.541-1.388 6.066 1.929 10.917-2.439 3.133-10.212 3.565-10.6l1.541-1.388.037-.031s1.211-.878 1.677-1.218 5.831 2.551 11.114-1.286 4.184-9.828 4.654-10.172 1.677-1.218 1.677-1.218l.041-.027 1.8-1.034c.5-.293 5.531 3.147 11.185-.119s5.191-9.335 5.691-9.627l1.8-1.037.041-.02s1.364-.606 1.895-.844 5.171 3.708 11.134 1.055 6.137-8.746 6.668-8.981l1.895-.844.048-.017 1.969-.643c.555-.177 4.756 4.229 10.964 2.215s7.018-8.055 7.572-8.236l1.97-.64.048-.014s1.456-.309 2.024-.432 4.29 4.7 10.675 3.347 7.821-7.277 8.392-7.4 2.028-.429 2.028-.429l.044-.01s1.487-.156 2.065-.214 3.773 5.123 10.263 4.443 8.539-6.419 9.117-6.484 2.062-.214 2.062-.214h2.123c.582 0 3.218 5.491 9.746 5.491s9.161-5.491 9.743-5.491h2.072",
    "data-name": "Path 382"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M435.233 254.462c0-115.513-93.639-209.151-209.151-209.151S16.927 138.95 16.927 254.462s93.642 209.152 209.155 209.152 209.151-93.639 209.151-209.152Z",
    "data-name": "Path 383"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M397.289 254.463a171.209 171.209 0 1 0-171.211 171.21 171.21 171.21 0 0 0 171.211-171.21Z",
    "data-name": "Path 384"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M172.969 162.997a3.174 3.174 0 0 1-4.324-1.157l-15.125-26.2a3.164 3.164 0 0 1 5.48-3.164l15.125 26.2a3.18 3.18 0 0 1-1.156 4.321Z",
    "data-name": "Path 388"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M134.426 201.639a3.174 3.174 0 0 1-4.324 1.157l-26.259-15.162a3.163 3.163 0 1 1 3.16-5.48l26.267 15.16a3.174 3.174 0 0 1 1.156 4.325Z",
    "data-name": "Path 389"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M97.401 254.34a3.175 3.175 0 0 1-3.164 3.164h-7.419a3.164 3.164 0 1 1 0-6.327h7.419a3.173 3.173 0 0 1 3.164 3.163Z",
    "data-name": "Path 390"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M134.08 307.239a3.173 3.173 0 0 1-1.16 4.324l-25.915 14.961a3.164 3.164 0 0 1-3.164-5.48l25.915-14.961a3.173 3.173 0 0 1 4.324 1.156Z",
    "data-name": "Path 391"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M173.068 345.505a3.175 3.175 0 0 1 1.16 4.324l-15.23 26.371a3.163 3.163 0 1 1-5.477-3.164l15.223-26.374a3.175 3.175 0 0 1 4.324-1.157Z",
    "data-name": "Path 392"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M225.705 383.12a3.174 3.174 0 0 1 3.167 3.164v6.946a3.166 3.166 0 0 1-6.331 0v-6.946a3.173 3.173 0 0 1 3.164-3.164Z",
    "data-name": "Path 393"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M278.749 346.213a3.175 3.175 0 0 1 4.324 1.16l14.818 25.667a3.163 3.163 0 1 1-5.477 3.164l-14.822-25.667a3.177 3.177 0 0 1 1.157-4.324Z",
    "data-name": "Path 394"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M317.778 307.497a3.177 3.177 0 0 1 4.324-1.16l25.466 14.706a3.164 3.164 0 1 1-3.164 5.48l-25.469-14.7a3.174 3.174 0 0 1-1.157-4.326Z",
    "data-name": "Path 395"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M355.715 254.34a3.174 3.174 0 0 1 3.167-3.164h5.712a3.164 3.164 0 1 1 0 6.327h-5.712a3.176 3.176 0 0 1-3.167-3.163Z",
    "data-name": "Path 396"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M316.924 201.673a3.17 3.17 0 0 1 1.16-4.324l26.32-15.2a3.164 3.164 0 1 1 3.164 5.48l-26.32 15.2a3.174 3.174 0 0 1-4.324-1.156Z",
    "data-name": "Path 397"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M278.868 162.253a3.177 3.177 0 0 1-1.157-4.324l14.7-25.452a3.164 3.164 0 1 1 5.48 3.164l-14.7 25.456a3.174 3.174 0 0 1-4.323 1.156Z",
    "data-name": "Path 398"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m302.231 352.411-20.493-20.493a3.41 3.41 0 0 1 0-4.81l13.4-13.4a3.41 3.41 0 0 1 4.81 0l20.49 20.489a3.42 3.42 0 0 1 0 4.814l-13.4 13.4a3.41 3.41 0 0 1-4.807 0Z",
    "data-name": "Path 399"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M370.836 254.463a144.755 144.755 0 1 0-144.758 144.754 144.757 144.757 0 0 0 144.758-144.754Z",
    "data-name": "Path 400"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m211.28 113.716 1.204 11.502",
    "data-name": "Line 453"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m196.636 116.035 2.405 11.315",
    "data-name": "Line 454"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m182.318 119.872 3.575 10.998",
    "data-name": "Line 455"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m168.481 125.184 4.705 10.566",
    "data-name": "Line 456"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m142.841 139.987 6.797 9.355",
    "data-name": "Line 457"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m131.32 149.316 7.739 8.593",
    "data-name": "Line 458"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m120.839 159.797 8.593 7.739",
    "data-name": "Line 459"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m111.511 171.318 9.355 6.797",
    "data-name": "Line 460"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m96.707 196.958 10.563 4.701",
    "data-name": "Line 461"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m91.395 210.796 10.998 3.572",
    "data-name": "Line 462"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m87.558 225.114 11.311 2.405",
    "data-name": "Line 463"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m85.239 239.755 11.502 1.208",
    "data-name": "Line 464"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m85.239 269.362 11.502-1.208",
    "data-name": "Line 465"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m87.558 284.002 11.311-2.405",
    "data-name": "Line 466"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m91.395 298.32 10.998-3.572",
    "data-name": "Line 467"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m96.707 312.158 10.563-4.701",
    "data-name": "Line 468"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m111.511 337.799 9.355-6.797",
    "data-name": "Line 469"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m120.839 349.319 8.593-7.739",
    "data-name": "Line 470"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m131.32 359.801 7.739-8.593",
    "data-name": "Line 471"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m142.841 369.129 6.797-9.355",
    "data-name": "Line 472"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m168.481 383.932 4.705-10.566",
    "data-name": "Line 473"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m182.318 389.243 3.575-10.998",
    "data-name": "Line 474"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m196.636 393.08 2.405-11.311",
    "data-name": "Line 475"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m211.28 395.399 1.204-11.502",
    "data-name": "Line 476"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m240.883 395.399-1.208-11.502",
    "data-name": "Line 477"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m255.523 393.08-2.402-11.311",
    "data-name": "Line 478"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m269.842 389.243-3.572-10.998",
    "data-name": "Line 479"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m283.682 383.932-4.705-10.566",
    "data-name": "Line 480"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m309.322 369.129-6.797-9.355",
    "data-name": "Line 481"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m320.842 359.801-7.739-8.593",
    "data-name": "Line 482"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m331.324 349.319-8.593-7.739",
    "data-name": "Line 483"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m340.652 337.799-9.355-6.797",
    "data-name": "Line 484"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m355.456 312.158-10.563-4.701",
    "data-name": "Line 485"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m360.767 298.32-10.998-3.572",
    "data-name": "Line 486"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m364.604 284.002-11.311-2.405",
    "data-name": "Line 487"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m366.924 269.362-11.502-1.208",
    "data-name": "Line 488"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m366.924 239.755-11.502 1.208",
    "data-name": "Line 489"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m364.604 225.114-11.311 2.405",
    "data-name": "Line 490"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m360.767 210.796-10.998 3.572",
    "data-name": "Line 491"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m355.456 196.958-10.563 4.701",
    "data-name": "Line 492"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m340.652 171.318-9.355 6.797",
    "data-name": "Line 493"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m331.324 159.797-8.593 7.739",
    "data-name": "Line 494"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m320.842 149.316-7.739 8.593",
    "data-name": "Line 495"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m309.322 139.987-6.797 9.355",
    "data-name": "Line 496"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m283.682 125.184-4.705 10.566",
    "data-name": "Line 497"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m269.842 119.872-3.572 10.998",
    "data-name": "Line 498"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m255.523 116.035-2.402 11.315",
    "data-name": "Line 499"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m240.883 113.716-1.208 11.502",
    "data-name": "Line 500"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M226.08 69.517V83.25",
    "data-name": "Line 501"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m216.396 69.771.721 13.713",
    "data-name": "Line 502"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m206.738 70.531 1.436 13.658",
    "data-name": "Line 503"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m197.134 71.796 2.15 13.563",
    "data-name": "Line 504"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m187.61 73.56 2.854 13.434",
    "data-name": "Line 505"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m178.188 75.823 3.555 13.264",
    "data-name": "Line 506"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m168.9 78.574 4.245 13.063",
    "data-name": "Line 507"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m159.767 81.807 4.922 12.822",
    "data-name": "Line 508"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m150.818 85.515 5.589 12.546",
    "data-name": "Line 509"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m142.074 89.686 6.235 12.236",
    "data-name": "Line 510"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m133.559 94.308 6.868 11.893",
    "data-name": "Line 511"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m125.301 99.37 7.481 11.519",
    "data-name": "Line 512"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m117.317 104.858 8.072 11.11",
    "data-name": "Line 513"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m109.63 110.754 8.644 10.672",
    "data-name": "Line 514"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m102.265 117.046 9.188 10.205",
    "data-name": "Line 515"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m95.239 123.714 9.709 9.712",
    "data-name": "Line 516"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m88.568 130.742 10.205 9.188",
    "data-name": "Line 517"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m82.276 138.109 10.675 8.644",
    "data-name": "Line 518"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m76.379 145.794 11.114 8.073",
    "data-name": "Line 519"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m70.894 153.777 11.519 7.481",
    "data-name": "Line 520"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m65.831 162.038 11.893 6.868",
    "data-name": "Line 521"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m61.207 170.55 12.24 6.236",
    "data-name": "Line 522"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m57.038 179.296 12.546 5.586",
    "data-name": "Line 523"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m53.33 188.246 12.821 4.923",
    "data-name": "Line 524"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m50.098 197.378 13.06 4.242",
    "data-name": "Line 525"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m47.344 206.667 13.267 3.552",
    "data-name": "Line 526"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m45.085 216.087 13.43 2.854",
    "data-name": "Line 527"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m43.318 225.611 13.563 2.15",
    "data-name": "Line 528"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m42.055 235.217 13.658 1.436",
    "data-name": "Line 529"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m41.294 244.874 13.713.718",
    "data-name": "Line 530"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M41.039 254.558h13.737",
    "data-name": "Line 531"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m41.294 264.243 13.713-.718",
    "data-name": "Line 532"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m42.055 273.9 13.658-1.436",
    "data-name": "Line 533"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m43.318 283.506 13.563-2.15",
    "data-name": "Line 534"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m45.085 293.03 13.43-2.854",
    "data-name": "Line 535"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m47.344 302.45 13.267-3.555",
    "data-name": "Line 536"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m50.098 311.738 13.06-4.245",
    "data-name": "Line 537"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m53.33 320.87 12.821-4.922",
    "data-name": "Line 538"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m57.038 329.82 12.546-5.586",
    "data-name": "Line 539"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m61.207 338.564 12.24-6.235",
    "data-name": "Line 540"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m65.831 347.078 11.893-6.868",
    "data-name": "Line 541"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m70.894 355.34 11.519-7.481",
    "data-name": "Line 542"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m76.379 363.321 11.114-8.072",
    "data-name": "Line 543"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m82.276 371.008 10.675-8.644",
    "data-name": "Line 544"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m88.568 378.374 10.205-9.188",
    "data-name": "Line 545"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m95.239 385.402 9.709-9.712",
    "data-name": "Line 546"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m102.265 392.069 9.188-10.205",
    "data-name": "Line 547"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m109.63 398.362 8.644-10.675",
    "data-name": "Line 548"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m117.317 404.258 8.072-11.11",
    "data-name": "Line 549"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m125.301 409.747 7.481-11.519",
    "data-name": "Line 550"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m133.559 414.809 6.868-11.896",
    "data-name": "Line 551"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m142.074 419.43 6.235-12.236",
    "data-name": "Line 552"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m150.818 423.6 5.589-12.546",
    "data-name": "Line 553"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m159.767 427.307 4.922-12.821",
    "data-name": "Line 554"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m168.9 430.543 4.245-13.063",
    "data-name": "Line 555"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m178.188 433.294 3.555-13.264",
    "data-name": "Line 556"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m187.61 435.556 2.854-13.434",
    "data-name": "Line 557"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m197.134 437.32 2.15-13.563",
    "data-name": "Line 558"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m206.738 438.586 1.436-13.662",
    "data-name": "Line 559"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m216.396 439.346.721-13.716",
    "data-name": "Line 560"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M226.08 439.599v-13.733",
    "data-name": "Line 561"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m235.767 439.346-.721-13.716",
    "data-name": "Line 562"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m245.425 438.586-1.436-13.662",
    "data-name": "Line 563"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m255.028 437.32-2.15-13.563",
    "data-name": "Line 564"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m264.553 435.556-2.854-13.434",
    "data-name": "Line 565"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m273.975 433.294-3.555-13.264",
    "data-name": "Line 566"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m283.263 430.543-4.246-13.063",
    "data-name": "Line 567"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m292.396 427.307-4.923-12.821",
    "data-name": "Line 568"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m301.345 423.6-5.589-12.546",
    "data-name": "Line 569"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m310.089 419.43-6.236-12.236",
    "data-name": "Line 570"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m318.6 414.809-6.868-11.896",
    "data-name": "Line 571"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m326.863 409.747-7.481-11.519",
    "data-name": "Line 572"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m334.845 404.258-8.073-11.11",
    "data-name": "Line 573"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m342.532 398.362-8.644-10.675",
    "data-name": "Line 574"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m349.897 392.069-9.188-10.205",
    "data-name": "Line 575"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m356.924 385.402-9.709-9.712",
    "data-name": "Line 576"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m363.595 378.374-10.209-9.188",
    "data-name": "Line 577"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m369.884 371.008-10.672-8.644",
    "data-name": "Line 578"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m375.783 363.321-11.114-8.072",
    "data-name": "Line 579"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m381.268 355.34-11.519-7.481",
    "data-name": "Line 580"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m386.331 347.078-11.893-6.868",
    "data-name": "Line 581"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m390.952 338.564-12.236-6.235",
    "data-name": "Line 582"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m395.125 329.82-12.546-5.586",
    "data-name": "Line 583"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m398.832 320.87-12.825-4.922",
    "data-name": "Line 584"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m402.065 311.738-13.06-4.245",
    "data-name": "Line 585"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m404.815 302.45-13.264-3.555",
    "data-name": "Line 586"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m407.078 293.03-13.431-2.854",
    "data-name": "Line 587"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m408.845 283.506-13.563-2.15",
    "data-name": "Line 588"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m410.107 273.9-13.658-1.436",
    "data-name": "Line 589"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m410.868 264.243-13.713-.718",
    "data-name": "Line 590"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "M411.12 254.558h-13.733",
    "data-name": "Line 591"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m410.868 244.874-13.713.718",
    "data-name": "Line 592"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m410.107 235.217-13.658 1.436",
    "data-name": "Line 593"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m408.845 225.611-13.563 2.15",
    "data-name": "Line 594"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m407.078 216.087-13.431 2.854",
    "data-name": "Line 595"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m404.815 206.667-13.264 3.552",
    "data-name": "Line 596"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m402.065 197.378-13.06 4.242",
    "data-name": "Line 597"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m398.832 188.246-12.825 4.923",
    "data-name": "Line 598"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m395.125 179.296-12.546 5.586",
    "data-name": "Line 599"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m390.952 170.55-12.236 6.236",
    "data-name": "Line 600"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m386.331 162.038-11.893 6.868",
    "data-name": "Line 601"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m381.268 153.777-11.519 7.481",
    "data-name": "Line 602"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m375.783 145.794-11.114 8.073",
    "data-name": "Line 603"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m369.884 138.109-10.672 8.644",
    "data-name": "Line 604"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m363.595 130.742-10.209 9.188",
    "data-name": "Line 605"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m356.924 123.714-9.709 9.712",
    "data-name": "Line 606"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m349.897 117.046-9.188 10.205",
    "data-name": "Line 607"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m342.532 110.754-8.644 10.672",
    "data-name": "Line 608"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m334.845 104.858-8.073 11.11",
    "data-name": "Line 609"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m326.863 99.37-7.481 11.519",
    "data-name": "Line 610"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m318.6 94.308-6.868 11.893",
    "data-name": "Line 611"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m310.089 89.686-6.236 12.236",
    "data-name": "Line 612"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m301.345 85.515-5.589 12.546",
    "data-name": "Line 613"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m292.396 81.807-4.923 12.822",
    "data-name": "Line 614"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m283.263 78.574-4.246 13.063",
    "data-name": "Line 615"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m273.975 75.823-3.555 13.264",
    "data-name": "Line 616"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m264.553 73.56-2.854 13.434",
    "data-name": "Line 617"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m255.028 71.796-2.15 13.563",
    "data-name": "Line 618"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m245.425 70.531-1.436 13.658",
    "data-name": "Line 619"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a1818",
    strokeWidth: 0.257,
    d: "m235.767 69.771-.721 13.713",
    "data-name": "Line 620"
  }))));
};
export { SvgBackgroundWatch as ReactComponent };
export default "/_next/static/images/backgroundWatch.svg";